









import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import Handsontable from 'handsontable'
import GridSettings = Handsontable.GridSettings
import RowObject = Handsontable.RowObject

@Component
export default class HotWrapper extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  options!: GridSettings & { data: never }

  @Prop({ type: Array, required: true }) data!: RowObject[]
  @Prop({ type: String, required: true }) id!: string
  @Prop(Boolean) fullSize!: boolean
  @Prop(String) searchQuery!: string
  @Prop(Function) searchFn!: <T>(item: T, query: string) => boolean

  @Ref('mountPoint') mountPoint!: HTMLElement

  hot: Handsontable | null = null

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const options: GridSettings = {
          ...this.options,
          data: this.data,
          persistentState: true,
          width: this.$parent.$el.clientWidth,
          search: true,
          autoWrapRow: true,
          autoColumnSize: true,
          stretchH: 'last',
          minSpareRows: 1,
          minRows: 1,
        }

        if (this.fullSize) {
          const top = this.$el.getBoundingClientRect().top
          options.height = document.documentElement.clientHeight - top
        }

        this.hot = new Handsontable(this.mountPoint, options)

        this.init()
      }, 150)
    })
  }

  @Watch('data', { immediate: true })
  updateData() {
    if (this.hot) {
      this.hot.updateSettings({ minSpareRows: 0 })
      this.hot.loadData(this.data)
      this.hot.updateSettings({ minSpareRows: 1 })
    }
  }

  @Watch('options')
  updateSettings() {
    // if (this.hot) {
    //   this.hot.updateSettings(this.options)
    // }
  }

  @Watch('searchQuery', { immediate: true })
  @Watch('hot', { immediate: true })
  @Watch('data', { immediate: true })
  searchInspections() {
    this.$nextTick(() => {
      const query = this.searchQuery
        ? this.searchQuery.toLowerCase().trim()
        : ''
      const hot = this.hot

      if (!hot) {
        return
      }

      const searchPlugin = hot.getPlugin('search')

      if (!query) {
        searchPlugin.query(query)
        hot.updateSettings({ trimRows: [] })

        return
      }

      const data = hot.getSourceData()
      const trimRows: number[] = []

      data.forEach((item, index) => {
        const isFind = this.searchFn(item, query)

        if (!isFind) {
          trimRows.push(index)
        }
      })

      searchPlugin.query(query)
      hot.updateSettings({ trimRows })
    })
  }

  @Emit()
  init() {
    return this.hot
  }
}
